export default {"src":"/_next/static/media/404.78641972.svg","height":346,"width":519,"blurWidth":0,"blurHeight":0};